import { CmsEffects } from './cms/effects/cms.effects';
import { CulturesEffect } from './cultures/effects/cultures.effect';
import { BaseSiteEffects } from './site-context/effects/site-context.effects';
import { ProductEffects } from './product/effects/product.effect';
import { BoelsAlternatesEffects } from './alternates/effects/boels-alternates.effects';
import { ProductSearchEffects } from './product-search/effects/product-search.effect';
import { GlobalProductSearchEffects } from './global-product-search/effects/global-product-search.effect';
import { CatalogsEffects } from './catalog/effects/catalogs.effect';
import { CartEffects } from './cart/effects/cart.effect';
import { ProductStockEffects } from './checkout/effects/product-stock.effects';
import { GlobalMessageEffect } from './global-message/effects/global-message.effect';
import { HolidaysEffect } from './holidays/effects/holidays.effects';
import { UserDataEffects } from './user-data/effects/user-data.effects';

export const effects = [
  BaseSiteEffects,
  CmsEffects,
  CulturesEffect,
  ProductEffects,
  BoelsAlternatesEffects,
  ProductSearchEffects,
  GlobalProductSearchEffects,
  CatalogsEffects,
  CartEffects,
  ProductStockEffects,
  GlobalMessageEffect,
  HolidaysEffect,
  UserDataEffects,
];
